module.exports = "::ng-deep .my-class .modal-dialog {\n  max-width: 80%;\n  width: 80%;\n  height: 100%;\n  overflow-y: hidden;\n  overflow-x: hidden; }\n\n.grid-cell-centered {\n  text-align: center; }\n\n::ng-deep #incident-accident-grid [col-id=\"Date\"].ag-cell {\n  text-decoration: underline;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/incident-accident/components/incident-accident-list/incident-accident-list.component.scss
// module id = ./src/app/incident-accident/components/incident-accident-list/incident-accident-list.component.scss
// module chunks = main